import type { Promocode, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_PROMOCODE_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllPromocodesQuery {
  promocodes: {
    edges: Promocode[]
    pageInfo: PageInfo
  }
}
export interface AllPromocodesQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_PROMOCODES = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    promocodes: allPromocodes(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
    edges {
      ${SHORTCUT_PROMOCODE_FIELDS}
    }
    pageInfo {
      ${SHORTCUT_PAGE_INFO_FIELDS}
    }
  }
}
`

export const useFetchAllPromocodes = (variables: AllPromocodesQueryVariables) =>
  useQuery<AllPromocodesQuery, AllPromocodesQueryVariables>(
    GQL_QUERY_ALL_PROMOCODES,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
